/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type optionsSection_company$ref: FragmentReference;
declare export opaque type optionsSection_company$fragmentType: optionsSection_company$ref;
export type optionsSection_company = {|
  +gitlabServerUrl: ?string,
  +jiraCloudEnabled: ?boolean,
  +jiraServerEnabled: ?boolean,
  +integrations: ?{|
    +jiraCloud: ?{|
      +syncSettings: ?{|
        +isJiraToForecastOneWaySync: ?boolean
      |}
    |},
    +jiraServer: ?{|
      +syncSettings: ?{|
        +isJiraToForecastOneWaySync: ?boolean
      |}
    |},
  |},
  +$refType: optionsSection_company$ref,
|};
export type optionsSection_company$data = optionsSection_company;
export type optionsSection_company$key = {
  +$data?: optionsSection_company$data,
  +$fragmentRefs: optionsSection_company$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "optionsSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gitlabServerUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraCloudEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraServerEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyIntegrationsType",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyJiraSettingsType",
          "kind": "LinkedField",
          "name": "jiraCloud",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyJiraSettingsType",
          "kind": "LinkedField",
          "name": "jiraServer",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
})();
// prettier-ignore
(node/*: any*/).hash = '3c3a5c6ee989497575c923ec74d3fb2a';

module.exports = node;
